import { get } from "lodash-es";
import { useRef } from "react";
import { useTemplatesContext } from "../context/templatesContext";
import { getTemplates } from "../repositories/TemplatesRepositorie";

type Props = {
	setIsLoading: (isLoading: boolean) => void;
	setError: (err: string) => void;
};

export const useSearchData = ({ setIsLoading, setError }: Props) => {
	const {
		state: { searchAssetIdToTable, searchText },
		actions: { setRows, setRowData },
	} = useTemplatesContext();

	const currentRequestRef = useRef(0);

	return async () => {
		const requestId = ++currentRequestRef.current;
		setIsLoading(true);
		const res = await getTemplates(searchAssetIdToTable, searchText);

		if (requestId !== currentRequestRef.current) {
			return;
		}

		if (res.ok) {
			const rowsSource = get(res, "data.tables[0].rows", []);
			rowsSource.forEach((row: any, index: number) => {
				row.id = row.TemplateId;
				row.GridId = index;
				row.hasDownTime = row.DowntimeClassCode === "D";
				row.hasOpenWorkOrders = row.HasOpenWorkOrders == 1 ? true : false;
				row.PeriodShifts = row.PeriodShifts / 2;
				row.WarningShifts = row.WarningShifts / 2;
				row.ExpectedShifts = row.ExpectedShifts / 2;
			});
			setRows(rowsSource);
			setRowData(rowsSource);
			setIsLoading(false);
		} else {
			setIsLoading(false);
			setError(res.message as string);
		}
	};
};
